import { render } from "./ContactFormPage.vue?vue&type=template&id=751bb82f&ts=true"
import script from "./ContactFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/ContactFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "751bb82f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('751bb82f', __exports__)) {
    api.reload('751bb82f', __exports__)
  }
  
  module.hot.accept("./ContactFormPage.vue?vue&type=template&id=751bb82f&ts=true", () => {
    api.rerender('751bb82f', render)
  })

}


export default __exports__